import React, { memo } from "react";
import TooltipV2 from "../../TooltipV2";
import ButtonIconV2 from "../../ButtonIconV2";
import { css } from "@linaria/core";

function ToolbarButton_({
  description,
  children,
  checked,
  disabled,
  onClick,
}: Pick<React.ComponentProps<typeof ButtonIconV2>, "checked" | "onClick" | "disabled"> &
  React.PropsWithChildren<{
    description: string;
  }>) {
  return (
    <TooltipV2
      placement="top"
      overlay={<div className={toolbarButtonDescription}>{description}</div>}
    >
      <div>
        <ButtonIconV2 onClick={onClick} checked={checked} disabled={disabled}>
          {children}
        </ButtonIconV2>
      </div>
    </TooltipV2>
  );
}

export const ToolbarButton = memo(ToolbarButton_);

const toolbarButtonDescription = css`
  max-width: 350px;
`;
